import { BaseService } from "./baseService";


export interface SetReminderResponse {
    success: boolean;
    message: string;
}

export class ReminderService extends BaseService {
    static async setReminder(eventKey: string, email: string): Promise<SetReminderResponse> {
        const response = await this.post("/reminders/set", {
            eventKey,
            email
        });
        return await this.handleResponse<SetReminderResponse>(response);
    }

    static async removeReminder(eventKey: string, email: string): Promise<SetReminderResponse> {
        const response = await this.post("/reminders/remove", {
            eventKey,
            email
        });
        return await this.handleResponse<SetReminderResponse>(response);
    }

    static async getUserReminders(email: string): Promise<{ eventKeys: string[] }> {
        const response = await this.get(`/reminders/user?email=${encodeURIComponent(email)}`);
        return await this.handleResponse<{ eventKeys: string[] }>(response);
    }
}
